import { FC } from 'react'
import { useSelector } from 'react-redux'

import { ToastsContainer } from '@/containers'
import { Reducers } from '@/redux/reducers'
import { Toast } from '@/types'

export const ConnectedToastsContainer: FC = () => {
    const toasts = useSelector<Reducers, Toast[]>(state => state.toastsReducer.toasts)

    return (
        <ToastsContainer toasts={toasts} />
    )
}
